import React from "react";
import {
  GivenNameField,
  FamilyNameField,
  EmailField
} from "../../shared/fields";
import { PasswordField } from "./fields";

const NonCoppaUpdateUserFormFields = () => {
  return (
    <>
      <GivenNameField />
      <FamilyNameField />
      <EmailField
        id={"primary-email"}
        className={"primary-email"}
        name={"primaryEmail"}
      />
      <PasswordField />
    </>
  );
};

export default NonCoppaUpdateUserFormFields;
